import { createSlice } from '@reduxjs/toolkit';
import { IScheduledValue } from '../../../../dto';
import { setScheduledValues } from '../actions';
import { MN_SCHEDULED_VALUES, TYPE_LIST } from '../../../../common';

export interface ScheduledValuesState {
  data: IScheduledValue[];
  loading: boolean;
  error: string | null;
}

const initialState: ScheduledValuesState = {
  data: [],
  loading: false,
  error: null,
};

export const scheduledValuesSlice = createSlice({
  name: `${MN_SCHEDULED_VALUES}/${TYPE_LIST}`,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setScheduledValues, (state, { payload }) => {
      state.data = payload;
    });
  },
});
